import { ChatIcon } from '@/components/Icons';
import { Link } from 'react-router-dom';
import './styles.scss';

interface HeaderSectionProps {
  onContactClick: () => void;
  withButton?: boolean;
}

export const HeaderSection = ({
  onContactClick,
  withButton = true,
}: HeaderSectionProps) => {
  return (
    <header>
      <div className='container header-container'>
        <div className='header-content'>
          <Link to='/' className='logo-link'>
            <img src='/logo.svg' alt='PlayWall Logo' className='logo' />
          </Link>
          {withButton && (
            <button
              className='contact-button desktop-only'
              onClick={onContactClick}
            >
              <ChatIcon />
              <span>Contact us</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
